import { render } from "./ListadoMarcasCpes.vue?vue&type=template&id=3a248314&scoped=true"
import script from "./ListadoMarcasCpes.vue?vue&type=script&lang=js"
export * from "./ListadoMarcasCpes.vue?vue&type=script&lang=js"

import "./ListadoMarcasCpes.vue?vue&type=style&index=0&id=3a248314&lang=scss&scoped=true"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a248314"]])

export default __exports__